import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faPenToSquare,
    faXmark,
    faHourglassHalf,
    faExternalLinkAlt,
    faPlus,
    faFloppyDisk,
    faUserPlus,
    faEnvelopeCircleCheck,
    faEnvelope,
    faKey,
    // 💡 Tip-related icons
    faLightbulb,       // idea / tip icon
    faInfoCircle,      // informational tip
    faCommentDots,     // conversational tip
    faStar,             // pro tip / highlight
    faScaleBalanced,
    faGavel,
    faFileContract,
    faCircleInfo,
    faInfo,
    faIdCard,
    faUser,
    faTriangleExclamation,
    faGlobe,
    faUsers,
    faBookmark,
} from "@fortawesome/free-solid-svg-icons";

// ✅ Add them all to the library so you can use anywhere in the app
library.add(
    faPenToSquare,
    faXmark,
    faHourglassHalf,
    faExternalLinkAlt,
    faPlus,
    faFloppyDisk,
    faUserPlus,
    faEnvelopeCircleCheck,
    faEnvelope,
    faKey,
    faLightbulb,       // 💡 Use: <FontAwesomeIcon icon="lightbulb" />
    faInfoCircle,      // ℹ️ Use: <FontAwesomeIcon icon="info-circle" />
    faCommentDots,     // 💬 Use: <FontAwesomeIcon icon="comment-dots" />
    faStar,             // ⭐ Use: <FontAwesomeIcon icon="star" />
    faScaleBalanced,
    faGavel,
    faFileContract,
    faCircleInfo,
    faInfo,
    faIdCard,
    faUser,
    faTriangleExclamation,
    faGlobe,
    faUsers,
    faBookmark,
);